// Kontrakt API skanera (FE ↔ wtyczka Nota). Źródło prawdy dla części C#.
// Enumy stringowe — muszą się zgadzać z JsonStringEnumConverter po stronie wtyczki.

export enum EScanColorMode {
  Color = "Color",
  Grayscale = "Grayscale",
  BlackWhite = "BlackWhite",
}

export enum EScanSource {
  Flatbed = "Flatbed", // szyba
  Feeder = "Feeder", // podajnik automatyczny (ADF)
}

export enum EScanJobState {
  Scanning = "Scanning",
  Completed = "Completed",
  Canceled = "Canceled",
  Faulted = "Faulted",
}

export interface IScannerDevice {
  Id: string;
  Name: string;
  Vendor?: string;
  HasFeeder: boolean;
  HasDuplex: boolean;
  Resolutions: number[]; // wspierane DPI
  ColorModes: EScanColorMode[];
}

export interface IScanStartRequest {
  DeviceId: string;
  Dpi: number;
  ColorMode: EScanColorMode;
  Source: EScanSource;
  Duplex: boolean; // istotne tylko dla Source = Feeder
}

export interface IScanStartResponse {
  JobId: string;
}

export interface IScanPage {
  Index: number; // kolejność ze skanera (0-based)
  Thumbnail: string; // base64 JPEG (bez prefiksu "data:")
  Width: number;
  Height: number;
}

export interface IScanJobStatus {
  JobId: string;
  State: EScanJobState;
  Pages: IScanPage[];
  Error?: string; // wypełnione gdy State = Faulted
}
